

export interface DatabaseSettings {
    settings: Record<string, string>;
}
